import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "poster-img" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isPosterVisible.value)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "pw-player-poster player-adon poster-background",
        onClick: _cache[1] || (_cache[1] = () => _ctx.play()),
        style: _ctx.cssVars
      }, [
        _hoisted_1
      ], 4))
    : _createCommentVNode("", true)
}